module.exports = __webpack_public_path__ + "static/media/logistics.985e7b19.svg";